import { useEffect } from 'react';

// Each page names itself in the tab and in search results.
export default function useTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · DeepDime` : 'DeepDime';
    return () => { document.title = prev; };
  }, [title]);
}
